import { Box, Typography } from '@mui/material';
import { useEffect, useRef } from 'react';

const Hero = () => {
    const heroRef = useRef(null);
    const targetY = useRef(0);
    const currentY = useRef(0);
    const animationId = useRef(null);

    useEffect(() => {
        const lerp = (start, end, factor) => start + (end - start) * factor;
        const ease = 0.08; // Lower = smoother/slower, higher = more responsive
        const parallaxSpeed = 0.3;

        const animate = () => {
            // Smoothly interpolate current position toward target
            currentY.current = lerp(currentY.current, targetY.current, ease);
            
            // Apply only if there's meaningful change (performance optimization)
            if (Math.abs(currentY.current - targetY.current) > 0.01) {
                if (heroRef.current) {
                    heroRef.current.style.backgroundPositionY = `calc(50% + ${currentY.current}px)`;
                }
            }
            
            animationId.current = requestAnimationFrame(animate);
        };

        const handleScroll = () => {
            targetY.current = window.scrollY * parallaxSpeed;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        animationId.current = requestAnimationFrame(animate);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (animationId.current) {
                cancelAnimationFrame(animationId.current);
            }
        };
    }, []);

    return (
        <div className='hero' ref={heroRef}>
            <Box sx={{ 
                position: 'relative', 
                zIndex: 1, 
                textAlign: 'center', 
                maxWidth: '900px',
                padding: { xs: '40px 20px', md: '60px 40px' },
            }}>
                <Typography 
                    variant="h1" 
                    sx={{ 
                        fontSize: { xs: '2.5rem', md: '3.5rem', lg: '4rem' },
                        fontWeight: 700,
                        marginBottom: '24px',
                        textShadow: '0 0 30px rgba(0, 0, 0, 1), 0 0 60px rgba(0, 0, 0, 0.9), 0 2px 4px rgba(0, 0, 0, 1), 0 4px 20px rgba(0, 0, 0, 0.95)',
                        fontFamily: 'Avenir Next LT Pro, sans-serif',
                        letterSpacing: '-0.02em',
                        lineHeight: 1.1,
                    }}
                >
                    Process Mastery Through Build Transparency
                </Typography>
                <Typography 
                    variant="h5" 
                    sx={{ 
                        fontSize: { xs: '1rem', md: '1.25rem', lg: '1.35rem' },
                        fontWeight: 500,
                        opacity: 1,
                        lineHeight: 1.7,
                        textShadow: '0 0 25px rgba(0, 0, 0, 1), 0 0 50px rgba(0, 0, 0, 0.9), 0 2px 4px rgba(0, 0, 0, 1)',
                        color: 'rgba(255, 255, 255, 0.95)',
                        maxWidth: '750px',
                        margin: '0 auto',
                    }}
                >
                    Reproducible digital threads optimizing LPBF additive manufacturing for first-time-right qualification.
                </Typography>
            </Box>
            <a href="#projects" className="scroll-indicator" aria-label="Scroll to projects section">
                <span className="scroll-indicator__chevron" />
                <span className="scroll-indicator__chevron" />
                <span className="scroll-indicator__chevron" />
            </a>
        </div>
    );
};

export default Hero;